import GuestlistCreateModalController from '../../controllers/modals/create-modal-controller';
import createModalTemplate from '../../views/modals/create-modal.tpl.html';
import GuestlistAfterCreateModalController from '../../controllers/modals/after-create-modal-controller';
import afterCreateModalTemplate from '../../views/modals/after-create-modal.tpl.html';

export default class AlGuestlistsGridViewController {

    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this.api = this.injector.get('$http');
        this.depositHelper = this.injector.get('Deposit');
        this.uibModal = this.injector.get('$uibModal');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');
        this.state = this.injector.get('$state');

        this.hideHeader = false;
        this.onSwitchToListView = () => {
        };

        this.loading = true;
        this.localStorageKey = 'AlGuestlistGridViewFastPipeConfig';
        this.guestlists = [];
        this.guestlistStates = [];

        this._initFastPipeConfiguration();

        this.sortDirections = [
            {
                key: 'asc',
                name: 'A-Z'
            },
            {
                key: 'desc',
                name: 'Z-A'
            }
        ];

        this.sortFields = [
            {
                field: 'name',
                name: 'sort by name'
            },
            {
                field: 'settings_start_date',
                name: 'sort by start date'
            }
        ];

        this._getDeposits()
            .then(() => {
                this._loadGuestlists();
            });
    }

    $onInit() {
        this._initWatchers();
    }

    refreshGuestlists() {
        this.loading = true;
        localStorage.setItem(this.localStorageKey, JSON.stringify(this.fastPipeConfiguration));
        this._loadGuestlists();
    }

    updateFastPipeConfigurationField(fieldName, value) {
        _.set(this.fastPipeConfiguration, fieldName, value);
        this.refreshGuestlists();
    }

    switchToListView() {
        this.onSwitchToListView();
    }

    _loadGuestlists() {
        this.api
            .post(
                'fp/guestlists',
                this._getBodyDataForGuestlistsRequest()
            )
            .then(({data}) => {
                this.guestlists = _.map(data.data, (guestlist) => {
                    return this._transformInGuestlist(guestlist);
                });
                this.loading = false;
            })
    }

    _transformInGuestlist(guestlist) {
        const out = _.cloneDeep(guestlist)
        _.each(this.guestlistStates, (status) => {
            if (out.status === status.label) {
                out.status = status.value;
                out.statusLabel = _.cloneDeep(status.label);
            }
        });
        return out;
    }

    _getBodyDataForGuestlistsRequest() {
        const filters = [];

        if (
            this.fastPipeConfiguration.statusFilter
            && this.fastPipeConfiguration.statusFilter.length > 0
        ) {
            filters.push({
                operator: 'group',
                filters: _.map(this.fastPipeConfiguration.statusFilter, (status) => {
                    return {
                        boolean: 'or',
                        field: 'status',
                        operator: '=',
                        value: status
                    };
                })
            })
        }

        const out = {
            fields: [
                'id',
                'name',
                'status',
                'sum_pax_planned_invited',
                'sum_pax_planned_confirmed',
                'sum_pax_actual',
                'settings_start_date',
                'settings_end_date',
                'sum_pax_actual_confirmed',
                'teaser_image',
                'guestlist_domain',
                'guestlist_path',
                'uid'
            ],
            filters,
            keyword: this.fastPipeConfiguration.keyword,
            pagination: {
                perPage: -1
            },
            sort: {}
        };

        out.sort[this.fastPipeConfiguration.sortField] = this.fastPipeConfiguration.sortDirection;

        return out;
    }

    _getDeposits() {
        return this.depositHelper
            .getRemoteDeposit('guestlists', 'states')
            .then((data) => {
                this.guestlistStates = _.map(data, (value, key) => {
                    return {
                        value: key,
                        label: value
                    };
                });
            })
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.fastPipeConfiguration.keyword,
            () => this.refreshGuestlists(),
            true
        );
    }

    _initFastPipeConfiguration() {
        let config = {
            statusFilter: [],
            keyword: '',
            sortField: 'settings_start_date',
            sortDirection: 'desc'
        };

        const localStorageContents = localStorage.getItem(this.localStorageKey);
        try {
            config = _.defaults(JSON.parse(localStorageContents), config);
        } catch (e) {
        }
        config.keyword = '';

        this.fastPipeConfiguration = config;
    }

    createGuestlist() {
        return this.uibModal.open({
            controller: GuestlistCreateModalController,
            keyboard: false,
            backdrop: 'static',
            controllerAs: 'vm',
            templateUrl: createModalTemplate
        }).result.then((data) => {
            const guestlistData = data.guestlist;

            this.alert.success(
                this.translate.instant('guestlists.workflows.create-guestlist.messages.created.title'),
                this.translate.instant('guestlists.workflows.create-guestlist.messages.created.message')
            );
            this.state.go('app.guestlists.rsvps.index', {gid: guestlistData.id});

            return this.uibModal.open({
                controller: GuestlistAfterCreateModalController,
                controllerAs: 'vm',
                templateUrl: afterCreateModalTemplate,
                resolve: {
                    guestlist: () => {
                        return guestlistData;
                    }
                }
            }).result.then(() => {

            }, () => {

            });
        }, () => {
            console.log('modal closed');
        })
    }
}

AlGuestlistsGridViewController.$inject = [
    '$scope',
    '$injector'
]



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlists-grid-view/controller.js